exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dashboard-container {\n  /* display: flex; */\n}\n", ""]);

// exports
